<template>

<!-- <el-table-column v-if="button" prop="" label="操作"    :width="200"  :fixed="'right'" > -->
<el-table-column prop=""  label="操作"    :width="120"  :fixed="fixed?'right':false" > 
	<template  slot="header" slot-scope="scope">
			  <div v-if="columnList.length>0&&$store.state.menu.meta.isColumns" @click="operateCommand('配置列')" class="el-dropdown"><button type="button" class="text-center el-button el-button--default el-button--mini el-dropdown-selfdefine"  ><!----><!----><span> 
			  			     配置列</span></button></div>
							 <div v-else class="text-center">操作栏</div>
		      </template>
<!-- <template slot="header" slot-scope="scope">
        <el-dropdown v-if="button.indexOf('添加')!=-1"  @command="operateCommand">
             
			  <el-button size="small"> 
			     操作栏<i class="el-icon-arrow-down el-icon--right"></i>
			   </el-button>
             <el-dropdown-menu slot="dropdown">
               <el-dropdown-item v-if="button.indexOf('添加')!=-1" command="添加">添加</el-dropdown-item>
			    <el-dropdown-item v-if="button.indexOf('导入')!=-1" command="导入">导入</el-dropdown-item>
				<el-dropdown-item v-if="button.indexOf('导出')!=-1" command="导出">导出</el-dropdown-item>
				<el-dropdown-item v-if="button.indexOf('打印')!=-1" command="打印">打印</el-dropdown-item>
				<el-dropdown-item v-if="button.indexOf('发货')!=-1" command="发货">发货</el-dropdown-item>
             </el-dropdown-menu>
           </el-dropdown>
		   <span v-else>操作栏</span> 
      </template> -->
	   <template slot-scope="scope">
		     <div style="min-height: 20px; text-align: center;">
		         <template  v-if="getButton.some(item=>item=='编辑')"> <el-link :underline="false"@click="editClick(scope.row,'编辑')"  class="text-primary pr-1">编辑</el-link></template>
			  <template  v-if="getButton.some(item=>item=='详情')">
		       <!-- <el-divider direction="vertical"></el-divider> -->
		       <el-link :underline="false"@click="editClick(scope.row,'详情')" class="text-blue pr-1">详情</el-link></template>
		      <template   v-if="getButton.some(item=>item=='复制')">
		      <!-- <el-divider   direction="vertical"></el-divider> -->
		      <el-link :underline="false" @click="editClick(scope.row,'复制')" class="text-success pr-1">复制</el-link></template>
			 <template  v-if="getButton.some(item=>item=='删除')">
			  <!-- <el-divider direction="vertical"></el-divider> -->
			  <el-link :underline="false" @click="deleteClick(scope.row,'删除')" class="text-danger pr-1">删除</el-link></template>
		     </div>
	       <!--   <el-button  @click="editClick(scope.row,'编辑')" type="text" size="small">编辑</el-button>
			   <el-button v-if="button.indexOf('详情')!=-1"  @click="editClick(scope.row,'详情')" type="text" size="small">详情</el-button>
			   <el-button v-if="button.indexOf('复制')!=-1"  @click="editClick(scope.row,'复制')" type="text" size="small">复制</el-button>
			  <el-button v-if="button.indexOf('删除')!=-1" @click="deleteClick(scope.row,'删除')" type="text" size="small">删除</el-button> -->
	        </template>
	  </el-table-column>
	  </template>
<script>
	  export default {
		      props: {
		      fixed:{
				  type:Boolean,
				  default:true
			  },
		      	pageData: {
		      		type: Array,
		      		default: () => []
		      	},
				columnList: {
					type: Array,
					default: () => []
				},
		      },
	    data() {
	      return {
			  button:'',
			 }
	    },
	    methods: {
			operateCommand(e){
				 this.$store.commit("saveOperate", e);
			 this.$emit("callbackOperate",{operate:e});     
			},
			editClick(e,text){
				 this.$store.commit("saveOperate", text);
			 this.$emit("callbackOperate",{operate:text,data:e}); 
			},
			deleteClick(e,text){
				this.$confirm("您确认要删除此记录吗", "操作提示", {
					type: 'warning'
				}).then(() => {
					this.$store.commit("saveSelect", [e]);
					this.editClick(e,text)
				}).catch(() => {});
			}
		},
			computed:{
			
				getButton(){
					
					return this.$store.state.menu.meta?(this.$store.state.menu.meta.button||'').split(','):[]
				}
			}
	  }
</script>

<style>
	.el-divider--vertical:first-child
	{ 
	display: none;
	}
</style>
